import { withAuth } from '@utilities/queries';
import { getDashboardRecentlyViewed } from '@simplywallst/services';

export default async function queryFn() {
  const response = await withAuth(getDashboardRecentlyViewed);
  const { data } = response.data;
  return data;
}
